<template>
  <v-select
    :value="value"
    :items="items"
    :item-text="itemText || undefined"
    :item-value="itemValue || undefined"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    class="select-dense"
    single-line
    outlined
    dense
    :clearable="clearable"
    :placeholder="placeholder || 'Filter'"
    hide-details="auto"
    flat
    height="24"
    :menu-props="{ bottom: true, offsetY: true, contentClass: 'select-dense-menu' }"
    background-
    color="text lighten1"
    item-color="secondary"
  />
</template>

<script>
export default {
  name: "select-dense",
  props: {
    items: Array,
    value: [String, Object],
    itemText: String,
    itemValue: String,
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
  },
};
</script>

<style>
.select-dense.v-select.v-text-field {
  margin-top: 4px;
  margin-bottom: 4px;
}

.select-dense.v-select.v-text-field .v-select__selections input::placeholder {
  color: var(--v-text-lighten1) !important;
}
.select-dense.v-select.v-text-field .v-select__selections input,
.select-dense.v-select.v-text-field .v-select__selections .v-select__selection {
  padding: 0 !important;
  font-size: 14px !important;
}
.select-dense.v-select.v-input--dense .v-select__selection--comma {
  margin: 0;
  margin-top: 1px;
}
.select-dense.v-input.v-select.v-text-field .v-input__slot {
  padding: 0 6px !important;
}

/* Vuetify min-height overrides */
.select-dense.v-select.v-text-field * {
  min-height: 0 !important;
}

.select-dense.v-select.v-text-field .v-input__append-inner {
  margin-top: 0px !important;
}

.select-dense.v-select.v-text-field .v-input__append-inner .v-input__icon {
  height: 24px;
}

.select-dense-menu .v-list .v-list-item {
  height: 28px !important;
  min-height: 0 !important;
}
.select-dense-menu .v-list .v-list-item .v-list-item__content {
  padding: 0 !important;
}
</style>
